"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const systems_1 = require("@/store/ducks/systems");
const index_view_1 = __importDefault(require("./index.view"));
function SitesListRow({ siteName, systems, siteId }) {
    const dispatch = (0, react_redux_1.useDispatch)();
    const onAddsSystem = react_1.default.useCallback(() => {
        dispatch((0, systems_1.openAddSystemModal)());
        dispatch((0, systems_1.setSelectedSiteOption)({ label: siteName, value: siteId }));
    }, [systems_1.openAddSystemModal, dispatch]);
    return (react_1.default.createElement(index_view_1.default, { siteName: siteName, systems: systems, onAddsSystem: onAddsSystem }));
}
exports.default = SitesListRow;
